import { pantryColors, pantryTypography } from '@pantry/ui'
import React from 'react'
import type { WHLocation } from '../../../../types/warehouse'
import type { SelectedLocations } from '../../utils/inviteLocationRoles'
import { Checkbox } from './styleHelpers'

const p = pantryColors
const F = pantryTypography.fontFamily

export interface LocationGridProps {
  warehouses: WHLocation[]
  value: SelectedLocations
  onChange: (next: SelectedLocations) => void
  errorMsg?: string
}

export const LocationGrid: React.FC<LocationGridProps> = ({
  warehouses,
  value,
  onChange,
  errorMsg,
}) => {
  const onToggleAll = (checked: boolean) => {
    if (checked) {
      onChange({ all: true, warehouseIds: [] })
    } else {
      // When 'All' is unchecked, start with no warehouses selected so the user
      // is forced to make an explicit choice.
      onChange({ all: false, warehouseIds: [] })
    }
  }

  const onToggleOne = (warehouseId: string, checked: boolean) => {
    const next = checked
      ? [...value.warehouseIds, warehouseId]
      : value.warehouseIds.filter((id) => id !== warehouseId)
    onChange({ all: false, warehouseIds: next })
  }

  return (
    <div>
      <div
        style={{
          fontSize: 12,
          color: p.gray[400],
          marginBottom: 6,
          fontFamily: F,
        }}
      >
        Locations access:
      </div>
      <div
        style={{
          display: 'grid',
          gridTemplateColumns: '1fr 1fr 1fr',
          gap: '4px 12px',
        }}
      >
        <Checkbox
          checked={value.all}
          onChange={onToggleAll}
          label="All locations"
        />
        {value.all
          ? null
          : warehouses.map((wh) => (
              <Checkbox
                key={wh.warehouse_id}
                checked={value.warehouseIds.includes(wh.warehouse_id)}
                onChange={(checked) => onToggleOne(wh.warehouse_id, checked)}
                label={wh.name}
              />
            ))}
      </div>
      {errorMsg ? (
        <div
          style={{
            fontSize: 12,
            color: '#DC2626',
            marginTop: 4,
            fontFamily: F,
          }}
        >
          {errorMsg}
        </div>
      ) : null}
    </div>
  )
}
